export default "__VITE_ASSET__ThYJaO9l__"